module.exports = __webpack_public_path__ + "static/media/BookWhite.bd5e676f.png";